import { useInstructionAPIFunctions } from "@/composables/api/instruction-api-functions"
import { type Moment } from "moment"
import { useAppInstructionStore } from "@/store/app-instructions.store"
import { Instruction } from "@/models/instruction.model"
import type { IInstruction } from "@/interfaces/api/instruction.interface"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import DataHelper from "@/helper/data-helper"

export default class AppInstructionsController {
  private appInstructionStore: ReturnType<typeof useAppInstructionStore> = useAppInstructionStore()

  public async retrieveInstructionsForDate(
    date: Moment,
    knownBusinessEntityContact: KnownBusinessEntityContact
  ) {
    const { retrieveInstructionsForServiceProviderOnDate } = useInstructionAPIFunctions()

    const response = await retrieveInstructionsForServiceProviderOnDate(
      knownBusinessEntityContact,
      date
    )
    const instructions = DataHelper.denormalizeData(response.data).map(
      (instruction: IInstruction) => new Instruction(instruction)
    )

    this.appInstructionStore.setInstructionsForDate(date, instructions)
  }

  public async retrieveSingleInstruction(instruction: Instruction) {
    const { retrieveSingleInstruction } = useInstructionAPIFunctions()
    const response = await retrieveSingleInstruction(instruction.id!)
    if (response.data.id) {
      return new Instruction(response.data)
    }
    return null
  }
}
